var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOtherBank = function SvgOtherBank(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5176\u4ED6\u94F6\u884C\u5361@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.121582%",
    y1: "0%",
    x2: "77.3242188%",
    y2: "103.94043%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8900",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5410B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9009\\u62E9\\u94F6\\u884C\\u5361",
    transform: "translate(-42.000000, -604.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-4",
    transform: "translate(22.000000, 580.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5176\\u4ED6\\u94F6\\u884C\\u5361",
    transform: "translate(20.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(6.384375, 1.391406)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37050523,6.6656368 C7.12485503,6.75395674 6.93146765,6.94734411 6.84314771,7.19299431 L4.24587041,14.416977 C4.21148112,14.5126263 4.23540157,14.619532 4.30727438,14.6914048 C4.40978701,14.7939174 4.57599282,14.7939174 4.67850544,14.6914048 L14.8689157,4.50099453 C14.9407885,4.42912172 14.964709,4.322216 14.9303197,4.22656675 C14.8812701,4.09014165 14.7309131,4.01930985 14.594488,4.0683595 L7.37050523,6.6656368 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 1.75,
    transform: "translate(9.588095, 9.410429) rotate(-315.000000) translate(-9.588095, -9.410429) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.2,
    y: 11.2,
    width: 4.2,
    height: 1.6,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    x: 5.4,
    y: 11.2,
    width: 4.2,
    height: 1.6,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    x: 9.6,
    y: 11.2,
    width: 4.2,
    height: 1.6,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    x: 13.8,
    y: 11.2,
    width: 4.2,
    height: 1.6,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 0.5,
    y: 21,
    width: 18.2,
    height: 1.6,
    rx: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.6,
    y: 11.8,
    width: 1.4,
    height: 9.8,
    rx: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 6.8,
    y: 11.8,
    width: 1.4,
    height: 9.8,
    rx: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 11,
    y: 11.8,
    width: 1.4,
    height: 9.8,
    rx: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 15.2,
    y: 11.8,
    width: 1.4,
    height: 9.8,
    rx: 0.7
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOtherBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/other-bank.cf26d077.svg";